export default "__VITE_ASSET__Cr$y0wA$__"